// @ts-nocheck
"use client";
import React, { useState, useEffect, useRef } from "react";
import { Reveal } from "./Hero";

/* ───────────────────────── PROBLEM (Chaos) ───────────────────────── */
function Problem() {
  const items = [
    { k: "01", t: "Pedidos desorganizados", d: "Notas, gritos, mesas confundidas. Lo que empieza como un servicio termina como un caos." },
    { k: "02", t: "Errores en cocina", d: "Sin trazabilidad ni estados claros, los platos se demoran, se duplican o se olvidan." },
    { k: "03", t: "Stock sin control", d: "Hojas sueltas y memoria. Productos que se agotan sin alerta y márgenes que se disuelven." },
    { k: "04", t: "Apps externas con comisiones", d: "Rappi, Uber, dependencia y poco control sobre tus propios clientes." },
    { k: "05", t: "Caja desordenada", d: "Cierres aproximados, diferencias sin explicar y reportes que llegan tarde." },
  ];
  return (
    <section className="ork-section ork-problem" id="problema">
      <div className="ork-problem-chaos" aria-hidden>
        <ChaosBackground />
      </div>
      <div className="ork-section-head">
        <Reveal as="span" className="ork-section-eyebrow">01 · El problema</Reveal>
        <Reveal as="h2" delay={120} className="ork-section-title">
          La operación de un restaurante <em>no falla</em> por falta de gente.
          <br/>Falla por falta de <span className="ork-accent">orquestación</span>.
        </Reveal>
      </div>

      <div className="ork-problem-grid">
        {items.map((it, i) => (
          <Reveal key={it.k} delay={i * 80} className="ork-problem-card">
            <div className="ork-problem-k">{it.k}</div>
            <div className="ork-problem-t">{it.t}</div>
            <div className="ork-problem-d">{it.d}</div>
            <ChaosLine seed={i} />
          </Reveal>
        ))}
      </div>
    </section>
  );
}

function ChaosBackground() {
  const labels = ["POS","Excel","WhatsApp","Rappi","Cocina","Caja","Mesero","Carta","Notas","Stock","Reservas","Domicilio"];
  const rnd = (seed) => {
    let s = seed;
    return () => { s = (s * 9301 + 49297) % 233280; return s / 233280; };
  };
  const r = rnd(7);
  const nodes = labels.map((t, i) => ({
    t,
    x: 60 + r() * 1080,
    y: 40 + r() * 320,
  }));
  const curves = [];
  for (let i = 0; i < 26; i++) {
    const a = nodes[Math.floor(r() * nodes.length)];
    const b = nodes[Math.floor(r() * nodes.length)];
    const cx = (a.x + b.x) / 2 + (r() - 0.5) * 200;
    const cy = (a.y + b.y) / 2 + (r() - 0.5) * 200;
    curves.push(`M${a.x},${a.y} Q${cx},${cy} ${b.x},${b.y}`);
  }
  return (
    <svg className="ork-chaos-bg" viewBox="0 0 1200 400" preserveAspectRatio="none">
      {curves.map((d, i) => (
        <path key={i} d={d} fill="none" stroke="currentColor" strokeWidth="1" strokeOpacity={0.18 + (i % 5) * 0.04}/>
      ))}
      {nodes.map((n, i) => (
        <g key={i} className="ork-chaos-node" transform={`translate(${n.x} ${n.y})`}>
          <rect x="-34" y="-12" width="68" height="24" rx="4" fill="var(--surface-1)" stroke="currentColor" strokeOpacity=".25"/>
          <text x="0" y="4" fontSize="10" textAnchor="middle" fill="currentColor" fillOpacity=".7" fontFamily="ui-sans-serif">{n.t}</text>
        </g>
      ))}
      {[0,1,2,3,4,5].map(i => (
        <text key={"q"+i} x={120 + i * 180 + (r()-.5)*60} y={i % 2 ? 70 : 340} fontSize="44" fill="currentColor" fillOpacity=".07" fontFamily="Instrument Serif, serif" fontStyle="italic">?</text>
      ))}
    </svg>
  );
}

function ChaosLine({ seed = 0 }) {
  const path = React.useMemo(() => {
    let s = seed * 7.13 + 1;
    const rand = () => { s = (s * 9301 + 49297) % 233280; return s / 233280; };
    const pts = [];
    for (let i = 0; i <= 20; i++) {
      pts.push([i * (200/20), 30 + (rand() - 0.5) * 40]);
    }
    return "M" + pts.map(p => p.join(",")).join(" L");
  }, [seed]);
  return (
    <svg className="ork-chaos-line" viewBox="0 0 200 60" preserveAspectRatio="none">
      <path d={path} fill="none" stroke="rgba(237,236,227,.4)" strokeWidth="1" />
    </svg>
  );
}

/* ───────────────────────── TRANSFORMATION ───────────────────────── */
function Transformation() {
  return (
    <section className="ork-section ork-transform" id="transform">
      <div className="ork-watermark" aria-hidden />
      <div className="ork-section-head">
        <Reveal as="span" className="ork-section-eyebrow">02 · La transformación</Reveal>
        <Reveal as="h2" delay={120} className="ork-section-title">
          De operación caótica<br/>
          a <span className="ork-accent">sistema orquestado</span>.
        </Reveal>
      </div>

      <div className="ork-transform-stage">
        <div className="ork-transform-col">
          <div className="ork-tr-label">Antes</div>
          <svg className="ork-tr-svg" viewBox="0 0 320 280" fill="none">
            {[
              { x: 60,  y: 50,  t: "Teléfono" },
              { x: 240, y: 60,  t: "Cocina" },
              { x: 90,  y: 150, t: "Excel" },
              { x: 260, y: 140, t: "Caja" },
              { x: 70,  y: 240, t: "WhatsApp" },
            ].map((n,i) => (
              <g key={i}>
                <rect x={n.x - 32} y={n.y - 12} width="64" height="24" rx="4" fill="#0E0E0E" stroke="rgba(120,120,120,.3)"/>
                <text x={n.x} y={n.y + 4} fontSize="9" textAnchor="middle" fill="rgba(255,255,255,.8)" fontFamily="ui-sans-serif">{n.t}</text>
              </g>
            ))}
            <path d="M60,50 C140,80 100,120 90,150"     stroke="rgba(120,120,120,.35)" strokeWidth=".9"/>
            <path d="M240,60 C220,90 230,110 260,140"    stroke="rgba(120,120,120,.35)" strokeWidth=".9"/>
            <path d="M90,150 C50,180 60,210 70,240"      stroke="rgba(120,120,120,.35)" strokeWidth=".9"/>
            <path d="M260,140 C200,100 140,80 60,50"     stroke="rgba(120,120,120,.35)" strokeWidth=".9"/>
            <path d="M240,60 C180,130 130,200 70,240"    stroke="rgba(120,120,120,.35)" strokeWidth=".9"/>
          </svg>
        </div>

        <div className="ork-transform-arrow" aria-hidden>
          <svg viewBox="0 0 80 24" width="80" height="24">
            <path d="M0 12 L70 12" stroke="var(--ork-text-3)" strokeWidth="1"/>
            <path d="M64 6 L74 12 L64 18" stroke="var(--ork-text-3)" strokeWidth="1" fill="none"/>
          </svg>
          <span>Orkestria</span>
        </div>

        <div className="ork-transform-col">
          <div className="ork-tr-label">Después</div>
          <svg className="ork-tr-svg" viewBox="0 0 320 280" fill="none">
            {[
              { x: 60,  y: 70,  t: "Pedidos" },
              { x: 160, y: 70,  t: "Cocina" },
              { x: 260, y: 70,  t: "Caja" },
              { x: 60,  y: 200, t: "Domicilios" },
              { x: 160, y: 200, t: "Carta" },
              { x: 260, y: 200, t: "Reportes" },
            ].map((n,i) => (
              <g key={i}>
                <rect x={n.x - 36} y={n.y - 12} width="72" height="24" rx="4" fill="#0B0B0B" stroke="rgba(37,99,235,.5)"/>
                <text x={n.x} y={n.y + 4} fontSize="9" textAnchor="middle" fill="rgba(255,255,255,.8)" fontFamily="ui-sans-serif">{n.t}</text>
              </g>
            ))}
            <path d="M96,70  L124,70"  stroke="rgba(37,99,235,.7)" strokeWidth="1"/>
            <path d="M196,70 L224,70"  stroke="rgba(37,99,235,.7)" strokeWidth="1"/>
            <path d="M96,200 L124,200" stroke="rgba(37,99,235,.7)" strokeWidth="1"/>
            <path d="M196,200 L224,200" stroke="rgba(37,99,235,.7)" strokeWidth="1"/>
            <path d="M60,82 C60,140 260,140 260,82"   stroke="rgba(37,99,235,.2)" strokeWidth="1" fill="none" strokeDasharray="2 3"/>
            <path d="M60,188 C60,140 260,140 260,188" stroke="rgba(37,99,235,.2)" strokeWidth="1" fill="none" strokeDasharray="2 3"/>
            <circle r="2.5" fill="rgba(37,99,235,.9)">
              <animateMotion dur="5s" repeatCount="indefinite" path="M60,70 L260,70 L260,200 L60,200 Z"/>
            </circle>
          </svg>
        </div>
      </div>

      <Reveal delay={300} className="ork-transform-quote">
        <span className="ork-quote-mark">“</span>
        Una herramienta sola no resuelve el caos. Lo orquesta el sistema entero.
      </Reveal>
    </section>
  );
}

/* ───────────────────────── SYSTEM (modules) ───────────────────────── */
function SystemSection() {
  const mods = [
    {
      n: "01",
      t: "Operación en tiempo real",
      d: "Pedidos, cocina y entrega sincronizados por WebSocket. Mesas con rondas por grupo, pre-cobro, corregir pedido con aviso a cocina y pantalla de cocina dedicada.",
      tags: ["Pedidos", "Cocina", "Mesas", "Rondas por grupo", "Pre-cobro", "Corregir pedido"],
      shot: "ops",
    },
    {
      n: "02",
      t: "Domicilios end-to-end",
      d: "Toma de pedido a domicilio, asignación de repartidor, estados de entrega y cobro al cierre — sin depender de plataformas externas.",
      tags: ["Toma", "Repartidor", "Entrega", "Cobro"],
      shot: "delivery",
    },
    {
      n: "03",
      t: "Caja, crédito y facturación",
      d: "Multi-caja con apertura/cierre con conteo, cobro multi-método, pago mixto, crédito (fiado) por cliente, ticket térmico 80mm, factura A4 y correo con rondas.",
      tags: ["Multi-caja", "Pago mixto", "Crédito", "Tickets", "Factura email"],
      shot: "cash",
    },
    {
      n: "04",
      t: "Menú avanzado y carta",
      d: "Productos con adiciones, combos, promociones por día y horario semanal de disponibilidad. Carta pública con 11 diseños y 11 paletas — extracción automática desde el logo.",
      tags: ["Adiciones", "Combos", "Promociones", "Horario semanal", "Carta pública"],
      shot: "menu",
    },
    {
      n: "05",
      t: "Equipo y permisos granulares",
      d: "8 roles operativos con permisos por sección. Invitaciones por correo, cuentas de clientes y miembros, y reservas con calendario semanal arrastrables.",
      tags: ["8 roles", "Invitaciones", "Reservas", "Clientes"],
      shot: "team",
    },
    {
      n: "06",
      t: "Analítica accionable",
      d: "Diez reportes seccionales, KPIs, comparativa con periodo anterior y dashboard agregado para dueños con varios restaurantes.",
      tags: ["KPIs", "Reportes", "Cross-restaurante"],
      shot: "chart",
    },
  ];

  return (
    <section className="ork-section ork-system" id="sistema">
      <div className="ork-section-head">
        <Reveal as="span" className="ork-section-eyebrow">03 · El sistema</Reveal>
        <Reveal as="h2" delay={120} className="ork-section-title">
          Una plataforma.<br/>
          <span className="ork-accent">Toda</span> tu operación.
        </Reveal>
        <Reveal as="p" delay={200} className="ork-section-lede">
          Seis módulos vivos, conectados por diseño. Todo lo que ves aquí ya está disponible en la plataforma.
        </Reveal>
      </div>

      <div className="ork-modules">
        {mods.map((m, i) => (
          <Reveal key={m.n} delay={i * 100} className="ork-module-card">
            <div className="ork-module-head">
              <span className="ork-module-n">{m.n}</span>
              <span className="ork-module-status"><i/> activo</span>
            </div>
            <h3 className="ork-module-t">{m.t}</h3>
            <p className="ork-module-d">{m.d}</p>
            <ModuleShot kind={m.shot} />
            <div className="ork-module-tags">
              {m.tags.map(t => <span key={t}>{t}</span>)}
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}

function ModuleShot({ kind }) {
  /* OPS — Tablero de cocina (igual al RestaurantKitchenBoard real) */
  if (kind === "ops") return (
    <div className="ork-mshot ork-mshot-kitchen">
      <div className="ork-mshot-kitchen-col">
        <div className="ork-mshot-kitchen-h" data-tone="amber">
          <span className="dot"/>En cocina
          <em>2</em>
        </div>
        <div className="ork-mshot-ticket" data-tone="amber">
          <div className="ork-mshot-ticket-h">
            <b>Mesa 12</b>
            <span className="ork-mshot-clock">⏱ 6m 42s</span>
          </div>
          <div className="ork-mshot-ticket-items">
            <div><i>2×</i> Bandeja paisa</div>
            <div><i>1×</i> Limonada de coco</div>
          </div>
          <div className="ork-mshot-ticket-tag">NUEVO</div>
        </div>
        <div className="ork-mshot-ticket" data-tone="amber">
          <div className="ork-mshot-ticket-h">
            <b>Mesa 4</b>
            <span className="ork-mshot-clock warn">⏱ 12m 08s</span>
          </div>
          <div className="ork-mshot-ticket-items">
            <div><i>1×</i> Pasta carbonara</div>
          </div>
        </div>
      </div>
      <div className="ork-mshot-kitchen-col">
        <div className="ork-mshot-kitchen-h" data-tone="emerald">
          <span className="dot"/>Listo
          <em>1</em>
        </div>
        <div className="ork-mshot-ticket" data-tone="emerald">
          <div className="ork-mshot-ticket-h">
            <b>Domicilio #049</b>
            <span className="ork-mshot-clock">⏱ 11m</span>
          </div>
          <div className="ork-mshot-ticket-items">
            <div><i>1×</i> Combo familiar</div>
          </div>
        </div>
      </div>
    </div>
  );

  /* CASH — Caja (igual al RestaurantCashierTab real) */
  if (kind === "cash") return (
    <div className="ork-mshot ork-mshot-cashier">
      <div className="ork-mshot-tables">
        {[
          { n: "M-1", st: "amber" },
          { n: "M-2", st: "blue" },
          { n: "M-3", st: "emerald" },
          { n: "M-4", st: "amber" },
          { n: "M-5", st: "muted" },
          { n: "M-6", st: "orange" },
        ].map((t) => (
          <div key={t.n} className="ork-mshot-table" data-st={t.st}>
            <span className="dot"/>
            <b>{t.n}</b>
          </div>
        ))}
      </div>
      <div className="ork-mshot-cashier-detail">
        <div className="ork-mshot-row"><span>Subtotal</span><b>$148.500</b></div>
        <div className="ork-mshot-row total"><span>Total</span><b>$163.350</b></div>
        <div className="ork-mshot-pays">
          {["Efectivo","Tarjeta","Transferencia","Cortesía"].map((p,i) => (
            <span key={p} data-active={i === 1 || undefined}>{p}</span>
          ))}
        </div>
      </div>
    </div>
  );

  /* CHART — Analítica (igual al RestaurantAnalyticsSalesTab real) */
  if (kind === "chart") return (
    <div className="ork-mshot ork-mshot-analytics">
      <div className="ork-mshot-kpis">
        {[
          { l: "Ingresos", v: "$74.2M", d: "+18%", up: true },
          { l: "Órdenes", v: "1.482", d: "+22", up: true },
          { l: "Ticket prom.", v: "$58.3k", d: "+4%", up: true },
        ].map((k) => (
          <div key={k.l} className="ork-mshot-kpi">
            <span>{k.l}</span>
            <b>{k.v}</b>
            <em className={k.up ? "up" : "down"}>{k.d}</em>
          </div>
        ))}
      </div>
      <div className="ork-mshot-chart">
        <svg viewBox="0 0 240 70" preserveAspectRatio="none" width="100%" height="70">
          <defs>
            <linearGradient id="cg-mod" x1="0" x2="0" y1="0" y2="1">
              <stop offset="0" stopColor="#2563eb" stopOpacity=".45"/>
              <stop offset="1" stopColor="#2563eb" stopOpacity="0"/>
            </linearGradient>
          </defs>
          <path d="M0,55 C30,45 50,52 80,32 C110,15 135,38 165,22 C190,12 215,28 240,18 L240,70 L0,70 Z" fill="url(#cg-mod)"/>
          <path d="M0,55 C30,45 50,52 80,32 C110,15 135,38 165,22 C190,12 215,28 240,18" fill="none" stroke="#2563eb" strokeWidth="1.4"/>
          {[14,28,42,56].map(y => (
            <line key={y} x1="0" x2="240" y1={y} y2={y} stroke="currentColor" strokeOpacity=".06"/>
          ))}
        </svg>
      </div>
    </div>
  );

  /* MENU — Carta digital (igual al RestaurantCartaTab real) */
  if (kind === "menu") return (
    <div className="ork-mshot ork-mshot-carta">
      <div className="ork-mshot-carta-row">
        <span className="ork-mshot-carta-label">Diseño</span>
        <div className="ork-mshot-carta-pill">
          <b>Lúmina Editorial</b>
          <em>elegante · serif</em>
        </div>
      </div>
      <div className="ork-mshot-carta-row">
        <span className="ork-mshot-carta-label">Paleta</span>
        <div className="ork-mshot-carta-swatches">
          {["#1a3a8a","#dccba1","#e3b86a","#3f4a6b","#8a6a4a"].map((c,i) => (
            <span key={c} style={{ background: c }} data-active={i === 1 || undefined}/>
          ))}
        </div>
      </div>
      <div className="ork-mshot-carta-preview">
        <div className="ork-mshot-carta-cat">ENTRADAS</div>
        <div className="ork-mshot-carta-item">
          <div>
            <b>Carpaccio de res</b>
            <span>láminas, rúcula, parmesano</span>
          </div>
          <em>$32.000</em>
        </div>
        <div className="ork-mshot-carta-item">
          <div>
            <b>Tartar de salmón</b>
            <span>aguacate, cítricos</span>
          </div>
          <em>$38.000</em>
        </div>
      </div>
    </div>
  );

  /* DELIVERY — Domicilios */
  if (kind === "delivery") return (
    <div className="ork-mshot ork-mshot-delivery">
      <div className="ork-mshot-delivery-list">
        {[
          { id: "#082", c: "Laura Méndez", st: "amber",   stT: "En camino",  rider: "Carlos R." },
          { id: "#081", c: "Tomás Ríos",   st: "blue",    stT: "Asignado",   rider: "Ana M."   },
          { id: "#080", c: "María José",   st: "emerald", stT: "Entregado",  rider: "Diego P." },
        ].map(d => (
          <div key={d.id} className="ork-mshot-delivery-row" data-st={d.st}>
            <div className="ork-mshot-delivery-id">{d.id}</div>
            <div className="ork-mshot-delivery-c">
              <b>{d.c}</b>
              <span>Repartidor · {d.rider}</span>
            </div>
            <div className="ork-mshot-delivery-st" data-st={d.st}>
              <i/> {d.stT}
            </div>
          </div>
        ))}
      </div>
      <div className="ork-mshot-delivery-foot">
        <span>Hoy</span>
        <b>38 domicilios · $1.240.000</b>
      </div>
    </div>
  );

  /* TEAM — Roles y permisos */
  if (kind === "team") return (
    <div className="ork-mshot ork-mshot-team">
      <div className="ork-mshot-team-grid">
        {[
          { r: "Dueño",    p: "Todo" },
          { r: "Admin",    p: "Gestión" },
          { r: "Mesero",   p: "Mesas · Pedidos" },
          { r: "Chef",     p: "Cocina" },
          { r: "Cajero",   p: "Caja · Facturas" },
          { r: "Domicilios", p: "Entregas" },
          { r: "Stock",    p: "Inventario" },
          { r: "Inv.",     p: "Compras" },
        ].map(t => (
          <div key={t.r} className="ork-mshot-team-cell">
            <b>{t.r}</b>
            <span>{t.p}</span>
          </div>
        ))}
      </div>
    </div>
  );

  return null;
}

/* ───────────────────────── PRICING ───────────────────────── */
const COP_PER_USD = 4000;
const NORMAL_MONTHLY_COP = 149000;
const ANNUAL_FREE_MONTHS = 2;

function formatCOP(n) {
  return "$" + n.toLocaleString("es-CO") + " COP";
}
function formatUSD(n) {
  return "$" + n.toFixed(0) + " USD";
}

function Pricing({ onContact }) {
  const [currency, setCurrency] = useState("COP");
  const [billing, setBilling] = useState("monthly");

  const rate = Number(process.env.NEXT_PUBLIC_COP_PER_USD) || COP_PER_USD;

  const normalMonthlyCOP = NORMAL_MONTHLY_COP;
  const normalAnnualTotalCOP = normalMonthlyCOP * (12 - ANNUAL_FREE_MONTHS);
  const normalAnnualPerMonthCOP = Math.round(normalAnnualTotalCOP / 12);

  const toUSD = (cop) => Math.round(cop / rate);

  const normalDisplayPrice =
    billing === "monthly"
      ? currency === "COP"
        ? formatCOP(normalMonthlyCOP)
        : formatUSD(toUSD(normalMonthlyCOP))
      : currency === "COP"
        ? formatCOP(normalAnnualPerMonthCOP)
        : formatUSD(toUSD(normalAnnualPerMonthCOP));

  const normalDisplayPer =
    billing === "monthly" ? "/restaurante/mes" : "/restaurante/mes · facturado anual";

  const normalAnnualEquivalent =
    billing === "annual"
      ? currency === "COP"
        ? "Total año: " + formatCOP(normalAnnualTotalCOP)
        : "Total año: " + formatUSD(toUSD(normalAnnualTotalCOP))
      : null;

  return (
    <section className="ork-section ork-pricing" id="planes">
      <div className="ork-section-head">
        <Reveal as="span" className="ork-section-eyebrow">04 · Planes</Reveal>
        <Reveal as="h2" delay={120} className="ork-section-title">
          Activa Orkestria.<br/>
          <span className="ork-accent">Paga por lo que usas</span>.
        </Reveal>
      </div>

      <div className="ork-pricing-toggles" role="group" aria-label="Opciones de plan">
        <div className="ork-toggle-group" role="radiogroup" aria-label="Moneda">
          <button
            type="button"
            data-active={currency === "COP" || undefined}
            onClick={() => setCurrency("COP")}
            aria-pressed={currency === "COP"}
          >
            COP
          </button>
          <button
            type="button"
            data-active={currency === "USD" || undefined}
            onClick={() => setCurrency("USD")}
            aria-pressed={currency === "USD"}
          >
            USD
          </button>
        </div>
        <div className="ork-toggle-group" role="radiogroup" aria-label="Periodicidad">
          <button
            type="button"
            data-active={billing === "monthly" || undefined}
            onClick={() => setBilling("monthly")}
            aria-pressed={billing === "monthly"}
          >
            Mensual
          </button>
          <button
            type="button"
            data-active={billing === "annual" || undefined}
            onClick={() => setBilling("annual")}
            aria-pressed={billing === "annual"}
          >
            Anual
          </button>
        </div>
        <span className="ork-toggle-discount">2 meses gratis al pagar anual</span>
      </div>

      <div className="ork-pricing-grid">
        <Reveal className="ork-tier featured">
          <span className="ork-tier-flag">Disponible</span>
          <div className="ork-tier-n">Orkestria</div>
          <div className="ork-tier-tag">Para un restaurante que quiere operar con control y crecer con datos.</div>
          <div className="ork-tier-price">
            <b>{normalDisplayPrice}</b>
            <em>{normalDisplayPer}</em>
          </div>
          {normalAnnualEquivalent && (
            <span className="ork-tier-savings">{normalAnnualEquivalent}</span>
          )}
          <ul>
            {[
              "Operación en tiempo real (pedidos, cocina, mesas, rondas por grupo)",
              "Pre-cobro, corregir pedido con aviso a cocina y pantalla de cocina dedicada",
              "Domicilios end-to-end: toma, asignación de repartidor, entrega y cobro",
              "Caja multi-caja con apertura/cierre con conteo y calculadora de cambio",
              "Cobro multi-método, pago mixto y crédito (fiado) por cliente",
              "Ticket térmico 80mm, factura A4 y envío por correo con rondas",
              "Menú avanzado: adiciones, combos, promociones por día y horario semanal",
              "Carta digital pública (11 diseños · 11 paletas) con QR y URL propia",
              "Reservas con calendario semanal arrastrables (también para meseros)",
              "Stock por producto con alertas en tiempo real",
              "8 roles operativos con permisos granulares e invitaciones por correo",
              "Móvil-first: barra inferior configurable y tour guiado por rol",
              "Faki, copiloto IA con page-agent visual y asistente en /docs",
              "Analítica completa (10 reportes seccionales)",
            ].map((b) => (
              <li key={b}>
                <svg width="10" height="10" viewBox="0 0 10 10"><path d="M1 5 L4 8 L9 2" stroke="currentColor" strokeWidth="1.5" fill="none"/></svg>
                {b}
              </li>
            ))}
          </ul>
          <button
            type="button"
            className="ork-btn-primary"
            onClick={() => onContact && onContact("access")}
          >
            Solicitar acceso <span aria-hidden>→</span>
          </button>
        </Reveal>

        <Reveal delay={100} className="ork-tier">
          <div className="ork-tier-n">Enterprise</div>
          <div className="ork-tier-tag">Para cadenas y grupos con varios locales.</div>
          <div className="ork-tier-price">
            <b>Hablemos</b>
            <em>precio según operación</em>
          </div>
          <ul>
            {[
              "Todo lo del plan Orkestria",
              "Multi-restaurante con dashboard agregado",
              "Soporte para múltiples monedas y países",
              "Onboarding y acompañamiento dedicado",
              "Acuerdo de nivel de servicio (SLA)",
              "Facturación a medida",
            ].map((b) => (
              <li key={b}>
                <svg width="10" height="10" viewBox="0 0 10 10"><path d="M1 5 L4 8 L9 2" stroke="currentColor" strokeWidth="1.5" fill="none"/></svg>
                {b}
              </li>
            ))}
          </ul>
          <button
            type="button"
            className="ork-btn-ghost"
            onClick={() => onContact && onContact("enterprise")}
          >
            Contáctanos <span aria-hidden>→</span>
          </button>
        </Reveal>
      </div>

      {currency === "USD" && (
        <p className="ork-rate-note">
          Conversión aproximada · 1 USD ≈ {rate.toLocaleString("es-CO")} COP. La factura se emite en pesos colombianos.
        </p>
      )}
    </section>
  );
}

/* ───────────────────────── FINAL CTA ───────────────────────── */
function FinalCTA({ onContact }) {
  return (
    <section className="ork-section ork-final" id="cta">
      <div className="ork-final-inner">
        <Reveal as="span" className="ork-section-eyebrow" style={{ display: "inline-block", marginBottom: 24 }}>En fase de prueba</Reveal>
        <Reveal as="h2" className="ork-final-title">
          Deja de improvisar.<br/>
          <span className="ork-accent">Empieza a orquestar.</span>
        </Reveal>
        <Reveal delay={120} as="p" className="ork-final-sub">
          Orkestria está en fase de prueba con restaurantes seleccionados. Solicita una demo personalizada y te mostramos cómo se adapta a tu operación.
        </Reveal>
        <Reveal delay={200} className="ork-final-actions">
          <button
            type="button"
            className="ork-btn-primary lg"
            onClick={() => onContact && onContact("demo")}
          >
            Solicitar demo <span aria-hidden>→</span>
          </button>
        </Reveal>
        <Reveal delay={320} className="ork-final-foot">
          <img src="/landing/orkestria-logo.png" alt="" />
          <span>Orkestria · Orquesta tu restaurante.</span>
        </Reveal>
      </div>
    </section>
  );
}

/* ───────────────────────── FOOTER ───────────────────────── */
function Footer({ basePath = "" }: { basePath?: string }) {
  const h = (anchor: string) => `${basePath}${anchor}`;
  return (
    <footer className="ork-footer">
      <div className="ork-footer-inner">
        <div className="ork-footer-brand">
          <img src="/landing/orkestria-logo.png" alt="Orkestria"/>
          <div>
            <b>Orkestria</b>
            <span>Sistema operativo para restaurantes.</span>
          </div>
        </div>
        <div className="ork-footer-cols">
          <div>
            <h4>Producto</h4>
            <a href={h("#sistema")}>Operación en tiempo real</a>
            <a href={h("#sistema")}>Domicilios</a>
            <a href={h("#sistema")}>Caja y facturación</a>
            <a href={h("#sistema")}>Menú y carta digital</a>
            <a href={h("#equipo")}>Equipo y roles</a>
            <a href={h("#faki")}>Faki (IA)</a>
            <a href={h("#sistema")}>Analítica</a>
          </div>
          <div>
            <h4>Compañía</h4>
            <a href={h("#planes")}>Planes</a>
            <a href={h("#cta")}>Solicitar demo</a>
          </div>
          <div>
            <h4>Recursos</h4>
            <a href="/docs">Documentación</a>
            <a href="/docs/changelogs">Changelogs</a>
            <a href="/docs/manual">Manual de usuario</a>
          </div>
          <div>
            <h4>Contacto</h4>
            <a href="mailto:orkestria@criskop.com">orkestria@criskop.com</a>
          </div>
        </div>
      </div>

      {/* Big Orkestria word — replica el estilo del hero pero más pequeño */}
      <div className="ork-footer-word" aria-hidden>
        <span className="ork-footer-word-line">
          <img className="ork-footer-word-O" src="/landing/orkestria-O-light.png" alt=""/>
          <span className="ork-footer-word-rest">rkestria</span>
        </span>
      </div>

      <div className="ork-footer-bottom">
        <span>© 2026 Orkestria · En fase de prueba</span>
        <a
          className="ork-footer-by"
          href="https://criskop.com"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Creado por CrisKop · abre en nueva pestaña"
        >
          <span>Creado por</span>
          <img className="ork-footer-by-crown" src="/landing/orkestria-crown-white.png" alt="CrisKop"/>
          <b>CrisKop</b>
        </a>
      </div>
    </footer>
  );
}

/* ───────────────────────── FAKI ───────────────────────── */
const FAKI_MESSAGES = [
  { from: "user", text: "¿Cuánto vendimos ayer en domicilios?" },
  { from: "faki", text: "Ayer: 38 órdenes de domicilio · $1.240.000 en ventas. Tu producto estrella fue la Hamburguesa Lúmina con 14 unidades." },
  { from: "user", text: "Cierra la caja del turno de hoy." },
  { from: "faki", text: "Caja del turno cerrada. Total recaudado: $2.880.500. Diferencia: $0. Reporte enviado a tu correo." },
];

function FakiSection() {
  const [msgIdx, setMsgIdx] = useState(0);

  useEffect(() => {
    const t = setInterval(() => {
      setMsgIdx((i) => (i + 1) % FAKI_MESSAGES.length);
    }, 2800);
    return () => clearInterval(t);
  }, []);

  const points = [
    { k: "Contexto total",     d: "Faki conoce tu carta, tus turnos, tu stock y tu caja en tiempo real." },
    { k: "Acciones directas",  d: "No solo responde — ejecuta. Cierra órdenes, consulta reportes, crea productos." },
    { k: "Page-agent visual",  d: "Te lleva al lugar exacto y resalta la sección con un anillo visual. Si cambias de pantalla, cancela solo." },
    { k: "Tour guiado por rol",d: "La primera vez que un miembro entra a un rol, Faki le da una guía interactiva paso a paso." },
    { k: "Asistente en /docs", d: "Faki conoce toda la documentación. Te responde con Markdown y enlaces directos a la sección." },
    { k: "Sin comandos",       d: "Escríbele como le escribirías a un colega. Él entiende la intención." },
  ];

  return (
    <section className="ork-section ork-faki" id="faki">
      <div className="ork-section-head">
        <Reveal as="span" className="ork-section-eyebrow">IA nativa</Reveal>
        <Reveal as="h2" delay={120} className="ork-section-title">
          Faki, tu copiloto<br /><em>dentro del sistema.</em>
        </Reveal>
      </div>

      <div className="ork-faki-grid">

        {/* Izquierda: texto + puntos */}
        <div>
          <Reveal delay={80}>
            <p style={{ fontSize: 16, color: "var(--ork-text-2)", lineHeight: 1.65, maxWidth: 440 }}>
              Faki es el agente de IA nativo de Orkestria. Vive dentro del dashboard,
              conoce tu operación en tiempo real y puede actuar por ti — no solo hablar.
            </p>
          </Reveal>

          <div className="ork-faki-points">
            {points.map(p => (
              <div key={p.k} className="ork-faki-point">
                <span>{p.k}</span>
                <b>{p.d}</b>
              </div>
            ))}
          </div>
        </div>

          {/* Derecha: card chat */}
          <div className="ork-faki-right">
            <div className="ork-faki-card">
              {/* Header */}
              <div className="ork-faki-card-head">
                <div className="ork-faki-avatar">
                  <div className="ork-faki-avatar-disc">
                    <img src="/landing/faki-icon.png" alt="Faki" />
                  </div>
                </div>
                <div>
                  <b>Faki</b>
                  <span>Copiloto · Orkestria</span>
                </div>
                <div className="ork-faki-pulse" />
              </div>

              {/* Mensajes */}
              <div className="ork-faki-card-body">
                {FAKI_MESSAGES.map((m, i) => (
                  <div
                    key={i}
                    className={`ork-faki-msg ork-faki-msg--${m.from}`}
                    data-on={i === msgIdx || undefined}
                  >
                    {m.text}
                  </div>
                ))}
              </div>

              {/* Footer input */}
              <div className="ork-faki-card-foot">
                <span>Faki</span>
                <input readOnly placeholder="Escríbele a Faki…" />
                <button type="button" aria-label="Enviar">
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M2 21l21-9L2 3v7l15 2-15 2v7z"/>
                  </svg>
                </button>
              </div>
            </div>
          </div>

      </div>
    </section>
  );
}

/* ───────────────────────── ROLES (Equipo) ───────────────────────── */
const ROLES = [
  { k: "owner",     t: "Dueño",          d: "Control total: restaurantes, miembros, facturación, planes y operación completa." },
  { k: "admin",     t: "Administrador",  d: "Gestión operativa y de equipo, sin tocar la información sensible del dueño." },
  { k: "waiter",    t: "Mesero",         d: "Toma de pedidos, rondas por grupo, reservas y creación de clientes desde el flujo." },
  { k: "chef",      t: "Chef / cocina",  d: "Pantalla de cocina dedicada con cola priorizada, estados y aviso de correcciones." },
  { k: "cashier",   t: "Cajero",         d: "Caja con apertura/cierre, cobro multi-método, pago mixto, crédito y reenvío de facturas." },
  { k: "delivery",  t: "Encargado de domicilios", d: "Toma de domicilios, asignación de repartidor, estados de entrega y cobro al cierre." },
  { k: "stock",     t: "Encargado de stock", d: "Inventario en tiempo real, alertas de bajo stock y ajustes con trazabilidad." },
  { k: "inventory", t: "Inventario",     d: "Compras, recepción y costeo — visibilidad sin acceso a operación de salón." },
];

function RolesSection() {
  return (
    <section className="ork-section ork-roles" id="equipo">
      <div className="ork-section-head">
        <Reveal as="span" className="ork-section-eyebrow">04 · Tu equipo</Reveal>
        <Reveal as="h2" delay={120} className="ork-section-title">
          Diseñado para <span className="ork-accent">cada rol</span><br/>
          de tu restaurante.
        </Reveal>
        <Reveal as="p" delay={200} className="ork-section-lede">
          Ocho roles con permisos granulares. Cada persona ve solo lo que necesita —
          con un tour guiado la primera vez que entra.
        </Reveal>
      </div>

      <div className="ork-roles-grid">
        {ROLES.map((r, i) => (
          <Reveal key={r.k} delay={i * 60} className="ork-role-card">
            <div className="ork-role-k">{String(i + 1).padStart(2, "0")}</div>
            <b className="ork-role-t">{r.t}</b>
            <p className="ork-role-d">{r.d}</p>
          </Reveal>
        ))}
      </div>
    </section>
  );
}

export { Problem, Transformation, SystemSection, FakiSection, RolesSection, Pricing, FinalCTA, Footer };
